import styled from 'styled-components';

export const DetailBodyMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        max-width: 120rem;
        margin: -1.3rem auto 0;
        z-index: 1;
    `
);
